import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gpus-3",
  "use": "icon-gpus-3-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-gpus-3\">\n  <g id=\"icon-gpus-3_组_5445\" data-name=\"组 5445\" transform=\"translate(-1145 -680)\">\n    <g id=\"icon-gpus-3_矩形_2266\" data-name=\"矩形 2266\" transform=\"translate(1145 680)\" fill=\"none\" stroke=\"#fa5252\" stroke-width=\"1\">\n      <rect width=\"12\" height=\"12\" stroke=\"none\" />\n      <rect x=\"0.5\" y=\"0.5\" width=\"11\" height=\"11\" fill=\"none\" />\n    </g>\n    <line id=\"icon-gpus-3_直线_70\" data-name=\"直线 70\" x2=\"11\" y2=\"11\" transform=\"translate(1145.5 680.5)\" fill=\"none\" stroke=\"#fa5252\" stroke-width=\"1\" />\n    <line id=\"icon-gpus-3_直线_71\" data-name=\"直线 71\" x1=\"11\" y2=\"11\" transform=\"translate(1145.5 680.5)\" fill=\"none\" stroke=\"#fa5252\" stroke-width=\"1\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gpus-3.svg
// module id = G3Fl
// module chunks = 103